// Amber warning shown above the auth card when no redirect_uri was supplied
// (RedirectInfo.source === 'fallback') — the sign-in destination is unknown
// and the panels keep their controls disabled.
export function FallbackBanner() {
  return (
    <div className="mb-4 rounded-xl border border-amber-300 bg-amber-50 p-4 shadow-sm dark:border-amber-400/30 dark:bg-amber-400/10">
      <div className="flex items-center gap-2">
        <svg
          className="h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={2}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
          />
        </svg>
        <p className="text-sm font-semibold text-amber-700 dark:text-amber-300">
          Unknown destination
        </p>
      </div>
      <p className="mt-1.5 text-left text-xs leading-relaxed text-amber-600 sm:text-sm dark:text-amber-400">
        No destination app was specified for this sign-in link —{' '}
        <span className="font-semibold text-red-600 dark:text-red-400">
          you may not end up where you expect
        </span>
        . This page{' '}
        <span className="font-semibold text-red-600 dark:text-red-400">must</span> be triggered
        from the app or resource you&apos;re trying to sign in to.
      </p>
    </div>
  );
}
